import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../styles/armsform.css';

const EditPassport = () => {
    const { state } = useLocation();
    const navigate = useNavigate();
    const [entry, setEntry] = useState(state?.entry ? { ...state.entry } : {});
    const [error, setError] = useState(null);
    const [showPopup, setShowPopup] = useState(false);
    const [loading, setLoading] = useState(false);

    // Debug the received state
    console.log('Received state:', state);
    console.log('Initial entry:', entry);

    // Check if we have valid entry data
    if (!state?.entry) {
        return (
            <div className="lc-form-container">
                <div className="lc-error-message">
                    No entry data found. Please go back and select an entry to edit.
                </div>
                <button 
                    type="button" 
                    className="lc-cancel-btn" 
                    onClick={() => navigate('/dashboard/passport-list')}
                >
                    Back to List
                </button>
            </div>
        );
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setEntry((prevEntry) => ({
            ...prevEntry,
            [name]: value,
        }));
    };

    const getDashboardUrl = () => {
        if (state?.userRole === 'admin') {
            return '/admin-dashboard';
        } else if (state?.userRole === 'pauid') {
            return '/passport-dashboard';
        } else {
            return '/passport-dashboard'; // default fallback
        }
    };

    const handleCancel = () => {
        navigate(getDashboardUrl());
    };

    const handleSave = async () => {
        console.log('Entry data before saving:', entry);
        
        // Validate required fields
        const requiredFields = ['token_id', 'local_no', 'name', 'father_name', 'cnic'];
        const missingFields = requiredFields.filter(field => !entry[field]);
        
        if (missingFields.length > 0) {
            setError(`Missing required fields: ${missingFields.join(', ')}`);
            return;
        }

        setLoading(true);
        setError(null);

        try {
            const response = await axios.post('https://chaman.gob.pk/eac_backend/edit-pass.php', {
                action: 'update',
                token_id: entry.token_id,
                local_no: entry.local_no,
                letter_no: entry.letter_no || '',
                date: entry.date || '',
                name: entry.name,
                father_name: entry.father_name,
                cnic: entry.cnic,
                address: entry.address || '',
                n_verification: entry.n_verification || '',
                t_report: entry.t_report || '',
                i_report: entry.i_report || '',
                phone_no: entry.phone_no || '',
                status: entry.status || 'Recieved'
            });

            console.log('Server response:', response.data);

            if (response.data?.status === 'success') {
                setShowPopup(true);
                setTimeout(() => {
                    setShowPopup(false);
                    navigate(getDashboardUrl());
                }, 2000);
            } else {
                const errorMsg = response.data?.message || 'Failed to update entry';
                setError(errorMsg);
            }
        } catch (err) {
            console.error('Update error:', err);
            if (err.response) {
                setError(`Server error: ${err.response.data?.message || err.response.status}`);
            } else if (err.request) {
                setError('Network error: Could not connect to server');
            } else {
                setError('Error: ' + err.message);
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="lc-form-container">
            <div className="lc-form-header">
                <h2>Edit Passport Entry</h2>
                <p>Token ID: {entry.token_id}</p>
            </div>

            <form className="lc-form" onSubmit={(e) => e.preventDefault()}>
                <div className="lc-left-section">
                    <div className="lc-form-group">
                        <label className="lc-label">Token ID:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="token_id"
                                value={entry.token_id || ''}
                                onChange={handleChange}
                                className="lc-input"
                                required
                                readOnly
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">No:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="local_no"
                                value={entry.local_no || ''}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Letter No:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="letter_no"
                                value={entry.letter_no || ''}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Date:</label>
                        <div className="lc-input-container">
                            <input
                                type="date"
                                name="date"
                                value={entry.date || ''}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Name:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="name"
                                value={entry.name || ''}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Father Name:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="father_name"
                                value={entry.father_name || ''}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">CNIC:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="cnic"
                                value={entry.cnic || ''}
                                onChange={handleChange}
                                className="lc-input"
                                required
                                pattern="[0-9]{5}-[0-9]{7}-[0-9]{1}"
                                placeholder="XXXXX-XXXXXXX-X"
                            />
                        </div>
                    </div>
                </div>

                <div className="lc-right-section">
                    <div className="lc-form-group">
                        <label className="lc-label">Address:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="address"
                                value={entry.address || ''}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">National Verification:</label>
                        <div className="lc-input-container">
                            <select
                                name="n_verification"
                                value={entry.n_verification || ''}
                                onChange={handleChange}
                                className="lc-select"
                            >
                                <option value="">Select Status</option>
                                <option value="Verified">Verified</option>
                                <option value="Not Verified">Not Verified</option>
                                <option value="In Process">In Process</option>
                            </select>
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Tehsildar Report:</label>
                        <div className="lc-input-container">
                            <select
                                name="t_report"
                                value={entry.t_report || ''}
                                onChange={handleChange}
                                className="lc-select"
                            >
                                <option value="">Select Status</option>
                                <option value="Submitted">Submitted</option>
                                <option value="Pending">Pending</option>
                                <option value="Verified">Verified</option>
                            </select>
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Incharge Report:</label>
                        <div className="lc-input-container">
                            <select
                                name="i_report"
                                value={entry.i_report || ''}
                                onChange={handleChange}
                                className="lc-select"
                            >
                                <option value="">Select Status</option>
                                <option value="Submitted">Submitted</option>
                                <option value="Pending">Pending</option>
                                <option value="Verified">Verified</option>
                            </select>
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Phone No:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="phone_no"
                                value={entry.phone_no || ''}
                                onChange={handleChange}
                                className="lc-input"
                                pattern="[0-9]{11}"
                                placeholder="03XXXXXXXXX"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Status:</label>
                        <div className="lc-input-container">
                            <select 
                                name="status" 
                                value={entry.status || 'Recieved'} 
                                onChange={handleChange}
                                className="lc-select"
                                required
                            >
                                <option value="Recieved">Received</option>
                                <option value="Ready">Ready</option>
                                <option value="Pending">Pending</option>
                                <option value="Completed">Completed</option>
                            </select>
                        </div>
                    </div>
                </div>
                
                <div className="lc-form-buttons">
                    <button 
                        type="button" 
                        className="lc-submit-btn" 
                        onClick={handleSave}
                        disabled={loading}
                    >
                        {loading ? 'Updating...' : 'Update'}
                    </button>
                    <button 
                        type="button" 
                        className="lc-cancel-btn" 
                        onClick={handleCancel}
                        disabled={loading}
                    >
                        Cancel
                    </button>
                </div>
            </form>
            
            {error && <div className="lc-error-message">{error}</div>}
            {showPopup && (
                <div className="lc-popup">
                    Entry updated successfully!
                </div>
            )}
        </div>
    );
};

export default EditPassport;